import { TrendingUp, TrendingDown, DollarSign } from "lucide-react";

export function KeyMetricsCard({keyMetricsData}) {
  const currentIncomeData = keyMetricsData?.month_incomes?.[0];
  const currentExpenseData = keyMetricsData?.month_expenses?.[0];
  const metrics = [
    {
      title: "Receitas deste mês",
      value: currentIncomeData && currentIncomeData.receitas_atuais ? `R$${currentIncomeData.receitas_atuais.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2})}` : "R$0,00",
      change: currentIncomeData && currentIncomeData.variacao_percentual ? `${currentIncomeData.variacao_percentual.toFixed(2)}%` : "0%",
      trend: currentIncomeData && currentIncomeData.variacao_percentual > 0 ? "up" : "down",
      icon: DollarSign
    },
    {
      title: "Despesas deste mês",
      value: currentExpenseData && currentExpenseData.gastos_atuais ? `R$${currentExpenseData.gastos_atuais.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2})}` : "R$0,00",
      change: currentExpenseData && currentExpenseData.variacao_percentual ? `${currentExpenseData.variacao_percentual.toFixed(2)}%` : "0%",
      trend: currentExpenseData && currentExpenseData.variacao_percentual > 0 ? "up" : "down",
      icon: currentExpenseData && currentExpenseData.variacao_percentual > 0 ? TrendingUp : TrendingDown,
      isExpense: true
    },
    {
      title: "Média diária de despesas",
      value: keyMetricsData?.average_daily_expense ? `R$${keyMetricsData.average_daily_expense.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2})}` : "R$0,00",
      change: keyMetricsData?.last_month_avg_expense ? `R$${keyMetricsData.last_month_avg_expense.toLocaleString('pt-BR', {minimumFractionDigits:2,maximumFractionDigits:2})} no mês passado` : "Sem dados do mês passado",
      trend: null,
      icon: DollarSign,
      isExpense: true
    }
  ];

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <h3 className="h5 fw-semibold mb-4">Metricas</h3>
        
        <div className="d-flex flex-column gap-4">
          {metrics.map((metric, index) => {
            const Icon = metric.icon;
            const isGoodTrend = metric.trend === null
              ? null
              : metric.isExpense ? metric.trend === "down" : metric.trend === "up";

            return (
              <div key={index} className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-3">
                  <div className="icon-container">
                    <Icon size={16} className="text-muted-custom" />
                  </div>
                  <div>
                    <p className="small text-muted-custom mb-1">{metric.title}</p>
                    <p className="h5 fw-semibold mb-0">{metric.value}</p>
                  </div>
                </div>

                <div className={`small fw-medium ${isGoodTrend === null ? 'text-muted-custom' : isGoodTrend ? 'text-primary-custom' : 'text-danger-custom'}`}>
                  {metric.change}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}